module.exports = __webpack_public_path__ + "img/bj@1x.560a19e6.png";